import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { formatNumber } from '../../../utils/formatNumber';

const RevenueBreakdown = ({ revenueByType, revenueByCity }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-warm">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center gap-2 text-xs">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry?.color }}
              />
              <span className="text-muted-foreground">{entry?.name}:</span>
              <span className="font-semibold text-foreground">
                {formatNumber(entry?.value)} ريال
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatYAxis = (value) => {
    return value >= 1000 ? `${formatNumber(value / 1000)}k` : formatNumber(value);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 md:mb-8">
      {/* Revenue by Photography Type */}
      <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
        <div className="mb-4">
          <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
            الإيرادات حسب نوع التصوير
          </h3>
          <p className="text-sm text-muted-foreground">
            توزيع الإيرادات على أنواع التصوير المختلفة
          </p>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={revenueByType} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="type"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="revenue"
              name="الإيرادات"
              fill="var(--color-primary)"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Revenue by City */}
      <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
        <div className="mb-4">
          <h3 className="text-lg md:text-xl font-bold text-foreground mb-1">
            الإيرادات حسب المدينة
          </h3>
          <p className="text-sm text-muted-foreground">
            توزيع الإيرادات على المدن السعودية
          </p>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={revenueByCity} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="city"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="revenue"
              name="الإيرادات"
              fill="var(--color-accent)"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueBreakdown;